/**
 * VCDR Backend Public APIs
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { VmcPoolApprovalModeEnum } from './vmcPoolApprovalModeEnum';


export interface TenantOrgCapabilitiesVmc { 
    /**
     * Pooled VMC org capability (enabled or disabled)
     */
    pooled_vmc_org?: boolean;
    vmc_link_mode?: VmcPoolApprovalModeEnum;
    vmc_unlink_mode?: VmcPoolApprovalModeEnum;
}
export namespace TenantOrgCapabilitiesVmc {
}


